<script>
	import { scaleAdOnHover, startAd, stopAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		comboVideo: {
			element: false,
			fallbackImgUrl: './../video/OPEL-SK001_ComboME_Phase2_WM_System.webp',
			imageAltText: 'Opel Combo - interactive Ad',
			videoUrl: './../video/OPEL-SK001_ComboME_Phase2_Verlaengerung.mp4',
			playTimeMs: 5000, //ganzes video von vorn = 14 sekunden + standbild bei 14 sekunden
			maxScale: 1,
			playing: false,
			autoStopTimeOut: false,
			posterImgOffsetS: 2,
			posterImg: './../video/OPEL-SK001_ComboME_Phase2_WM_System.webp',
			volume: 0
		}
	}
</script>

<div class="page-opel marginbox">
	<div class="flex structure">
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Ad-Design" src="./../img/19.Opel_Case_Study/04.idee/garage_small.webp">
			</div>
			
			<div class="flex element right">
				<div class="text">
					<h2>{getText("19.04.01_h2")}</h2>
					<p class="caption">{getText("19.04.02_caption")}</p>
				</div>
			</div>
		</div>
		
		<div class="flex row structure-2">
			<div class="flex element">
				<img loading="lazy" alt="Opel-Case-Study - Microfon" src="./../img/19.Opel_Case_Study/04.idee/Bildschirmfoto_2021-08-10 um_11.37.22.webp">
			</div>
		</div>
	</div>
	
	<div class="img-single">
		<!-- Beginning - comboVideo -->
		<div bind:this={ads.comboVideo.element} class="content">
			<div use:scaleAdOnHover={ads.comboVideo} class="commercial" on:click={() => !ads.comboVideo.playing ?
			startAd(ads.comboVideo, () => ads = ads) : null}>
				<video playsinline loop="true" on:loadeddata={() => stopAd(ads.comboVideo, () => ads = ads)} scrolling="no"
					   src={ads.comboVideo.videoUrl}/>
				{#if ads.comboVideo.playing}
					<!-- PLAYING -->
				{:else}
					<!-- NOT PLAYING -->
					<button aria-label="play Ad - {ads.comboVideo.imageAltText}" class="playbutton"></button>
				{/if}
			</div>
		</div>
		<!-- End - comboVideo -->
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin-bottom: $spacing-mobile;
	}
	
	.right {
		text-align: right;
		
		@include for-tablet-landscape-up {
			justify-content: end;
		}
	}
	
	.page-opel {
		h2 {
			margin-bottom: $media-gap;
		}
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: fit-content;
			line-height: 0;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
			margin-top: $spacing-mobile;
		}
		
		.structure-1 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			
			@include for-tablet-portrait-up {
				width: 50%;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-2 {
			width: 100%;
			padding: 0;
			
			@include for-tablet-portrait-up {
				width: 50%;
				padding-left: $media-gap;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.text {
			margin: 0;
		}
	}
	
	video {
		width: 100%;
	}
</style>
